import { loadImage } from '@/utils/fileDownload'

export const createPdfBlob = async (jpegDataUrl: string) => {
  const reportImage = await loadImage(jpegDataUrl)
  const binary = atob(jpegDataUrl.split(',')[1])
  const pageWidth = 842
  const imageWidth = 780
  const imageHeight = Math.round((reportImage.height / reportImage.width) * imageWidth)
  const pageHeight = imageHeight + 96
  const imageX = 31
  const imageY = 48
  const content = `q\n${imageWidth} 0 0 ${imageHeight} ${imageX} ${imageY} cm\n/Im0 Do\nQ`
  const objects = [
    '<< /Type /Catalog /Pages 2 0 R >>',
    '<< /Type /Pages /Kids [3 0 R] /Count 1 >>',
    `<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${pageWidth} ${pageHeight}] /Resources << /XObject << /Im0 4 0 R >> >> /Contents 5 0 R >>`,
    `<< /Type /XObject /Subtype /Image /Width ${reportImage.width} /Height ${reportImage.height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${binary.length} >>\nstream\n${binary}\nendstream`,
    `<< /Length ${content.length} >>\nstream\n${content}\nendstream`
  ]

  let pdfContent = '%PDF-1.4\n'
  const offsets: number[] = []
  objects.forEach((object, index) => {
    offsets.push(pdfContent.length)
    pdfContent += `${index + 1} 0 obj\n${object}\nendobj\n`
  })
  const xrefOffset = pdfContent.length
  pdfContent += `xref\n0 ${objects.length + 1}\n0000000000 65535 f \n`
  offsets.forEach((offset) => {
    pdfContent += `${String(offset).padStart(10, '0')} 00000 n \n`
  })
  pdfContent += `trailer\n<< /Size ${
    objects.length + 1
  } /Root 1 0 R >>\nstartxref\n${xrefOffset}\n%%EOF`

  const bytes = new Uint8Array(pdfContent.length)
  for (let byteIndex = 0; byteIndex < pdfContent.length; byteIndex += 1) {
    bytes[byteIndex] = pdfContent.charCodeAt(byteIndex) & 0xff
  }
  return new Blob([bytes], { type: 'application/pdf' })
}
